import React from 'react';
import { translate } from 'react-i18next';

import Grid from 'react-bootstrap/lib/Grid';
import Image from 'react-bootstrap/lib/Image';

import russiaIreland from './russia-ireland.png';

const Copyright = ({ t }) => (
  <Grid>
    <p>© 2015-{new Date().getFullYear()}, {t('BikesBooking')}, {t('All rights reserved')}</p>
    <p>{t('Made with love in Russia and Ireland')}</p>
    <Image
      alt="russia and ireland"
      draggable="false"
      src={russiaIreland}
      width={92}
      height={32}
    />
  </Grid>
);

export default translate(['translation'])(Copyright);



// WEBPACK FOOTER //
// ./src/widgets/Copyright/index.js